export default "__VITE_ASSET__D2ysu_eX__ 600w";